import axiosInstance from './api'

/**
 * Fetch Student Status report aggregates.
 * Predefined: pass `period`. Custom: pass `from` + `to` and omit `period`.
 * @param {{ period?: string, grade?: string, from?: string, to?: string }} params
 */
export const fetchStudentInsights = async ({
	period,
	grade = 'all',
	from,
	to,
} = {}) => {
	const params = {
		grade: grade === 'all' ? 'all' : grade,
	}
	if (from && to) {
		params.from = from
		params.to = to
	} else {
		params.period = period || 'academic-year'
	}
	const response = await axiosInstance.get('/counseling/reports/student-insights', {
		params,
	})
	return response.data
}

/**
 * Fetch Counsellor Report aggregates (My / Team).
 * Predefined: pass `period`. Custom: pass `from` + `to` and omit `period`.
 * @param {{ period?: string, from?: string, to?: string }} params
 */
export const fetchCounsellorInsights = async ({ period, from, to } = {}) => {
	const params = {}
	if (from && to) {
		params.from = from
		params.to = to
	} else {
		params.period = period || 'all-time'
	}
	const response = await axiosInstance.get('/counseling/reports/counsellor-insights', {
		params,
	})
	return response.data
}

/**
 * Fetch school-level compliance evidence collected flags.
 * @param {{ jurisdiction: string }} params
 */
export const fetchComplianceEvidence = async ({ jurisdiction } = {}) => {
	const response = await axiosInstance.get('/counseling/reports/compliance/evidence', {
		params: { jurisdiction },
	})
	return response.data
}

/**
 * Upsert one compliance evidence collected flag.
 * @param {{ jurisdictionId: string, evidenceId: string, collected: boolean }} params
 */
export const updateComplianceEvidence = async ({
	jurisdictionId,
	evidenceId,
	collected,
}) => {
	const response = await axiosInstance.put('/counseling/reports/compliance/evidence', {
		jurisdictionId,
		evidenceId,
		collected,
	})
	return response.data
}
